import React from 'react'
import { useTranslation } from 'react-i18next'

import { Col } from '../../../../../../packages/kiti/components/structure/Grid'
import { useForm } from '../../../../../../packages/kiti/components/form/form/FormHandler'
import CheckboxInput from '../../../../../../components/form/CheckboxInput'
import ColorPicker from '../../../../../../packages/kiti/components/form/ColorPicker'
import FormItem from '../../../../../../packages/kiti/components/form/form/FormItem'
import Select from '../../../../../../packages/kiti/components/form/Select'

const EditWidgetForm = () => {
  const { t } = useTranslation('common')
  const form = useForm()

  return (
    <>
      <Col width="100%">
        <FormItem label={t('widgets.color')} path={['data', 'color']} Input={ColorPicker} />
      </Col>

      <Col width="100%">
        <FormItem label={t('widgets.ignorePeriod')} path={['data', 'ignoreDate']} Input={CheckboxInput} ignoreLabel />
      </Col>

      <Col width="100%">
        <FormItem
          label={t('widgets.status')}
          path={['data', 'statuses']}
          Input={Select}
          options={[
            { id: undefined, name: t('widgets.all') },
            { id: 'open', name: t('widgets.open') },
            { id: 'done', name: t('widgets.done') }
          ]}
          selectOnlyId
        />
      </Col>

      <Col width="100%">
        <FormItem
          label={t('widgets.type')}
          path={['data', 'origins']}
          Input={Select}
          options={[
            { id: undefined, name: t('widgets.all') },
            { id: 'serviceOrder', name: t('widgets.activities') },
            { id: 'formReply', name: t('widgets.forms') }
          ]}
          selectOnlyId
        />
      </Col>
    </>
  )
}

export default EditWidgetForm
